export enum CaseAddressState {
  MISSING = 'MISSING',
  DIFFERENT = 'DIFFERENT',
  PARTIAL = 'PARTIAL',
  SAME = 'SAME'
}
